// extracted by mini-css-extract-plugin
export default {"cookieBanner":"CookieBanner_cookieBanner__Zom9w","cookieBannerContent":"CookieBanner_cookieBannerContent__+niG+"};